import { DatePicker } from '@frontend/legacy-components';

import type {
  ExcludableDateRelation,
  SingleDateRelationFilterValue,
  SingleDateValue,
} from './types';

type SingleDateInputProps<ExcludedRelations extends ExcludableDateRelation> = {
  relationFilterValue: SingleDateRelationFilterValue<ExcludedRelations>;
  onChange: (selectedDate: SingleDateValue) => void;
  dateTimeFormat: string;
  showTimeSettings: object | boolean;
};

const SingleDateInput = <ExcludedRelations extends ExcludableDateRelation>({
  relationFilterValue,
  onChange,
  dateTimeFormat,
  showTimeSettings,
}: SingleDateInputProps<ExcludedRelations>) => {
  return (
    <DatePicker
      value={relationFilterValue.startDate}
      onChange={onChange}
      format={dateTimeFormat}
      showTime={showTimeSettings}
      style={{
        width: '100%',
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
      }}
    />
  );
};

export default SingleDateInput;
